import type { ChartHistoryFilterType } from "@roman/shared/constants/predictionChart";

/**
 * Formats X-axis labels based on the display mode
 * @param value - The time value in "YYYY/MM/DD HH:mm" format
 * @param displayMode - The current chart display mode
 * @returns Formatted label string
 */
export const getXAxisFormatter = (value: string, displayMode: ChartHistoryFilterType): string => {
  const [date, time] = value.split(" ");
  const [, month, day] = date.split("/");

  switch (displayMode) {
    case "all": {
      // Show month only in Japanese (e.g., 6月, 11月)
      return `${Number.parseInt(month)}月`;
    }
    case "1M":
    case "1W": {
      // Show month and day in Japanese (e.g., 5/18, 6/1)
      return `${Number.parseInt(month)}/${Number.parseInt(day)}`;
    }
    case "1D": {
      // Show time in 24-hour format (e.g., 6:00, 18:00)
      const [hours] = time.split(":");
      const hour = Number.parseInt(hours);
      return `${hour}:00`;
    }
    default:
      return value;
  }
};

/**
 * Calculates appropriate tick interval to avoid overcrowding
 * @param dataLength - The number of data points
 * @returns The interval for showing ticks
 */
export const getTickInterval = (dataLength: number): number => {
  if (dataLength <= 7) return 0; // Show all ticks
  if (dataLength <= 14) return 1; // Show every other tick
  if (dataLength <= 30) return Math.floor(dataLength / 7); // Show ~7 ticks
  return Math.floor(dataLength / 10); // Show ~10 ticks for large datasets
};
